import { ETH_ADDRESS_REGEX } from './components/AddressField/constants';

export const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const isValidAddress = address => ETH_ADDRESS_REGEX.test(address);

export const parseName = (name) => {
  if (!name) return "";
  if (name.includes("-")) {
    return name.split("-").join(" ");
  }
  return name;
};

export const parseURL = (url) => {
  if (!url) return false;
  const urlArray = url.split("/custom/");
  if (urlArray.length < 2) return false;

  const urlData = urlArray[1].split("/");
  return {
    address: urlData[0],
    name: urlData[1],
  };
};